// Port of api/fuel/app/classes/insights/ratings/rankings.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'

export default Segment.extend({
	name: 'rankings',
	insight: ['ranking.band'],
	detail: false,
	run: function(type, owner, userIndex, detail, filter) {

		if (!owner.get_count_ratings()) return {}

		var own = []
		var bands = []
		var ratingBands = []
		var average = []
		var ratings = {}
		var counts = {}
		var stats = {
			top100: 0,
			top1000: 0,
			ranked: 0,
			highest: 0,
			lowest: 0,
			longest: [0, 0],
			levels: 0,
			levelmost: [0, 0],
			levelnone: [0, 0]
		}

		var currentBand = (filter['ranking.band'] !== undefined) ? filter['ranking.band'] : 1

		var ratingRows = Util.query(
			'SELECT g.game_id AS g, g.game_rank AS r, SUM(r.rating_value) AS v, COUNT(r.rating_id) AS c' +
			' FROM rating r JOIN game g' +
			' WHERE r.user_id IN (' + Util.in(userIndex) + ')' +
			' AND r.game_id = g.game_id' +
			' AND g.game_type = 1' +
			' GROUP BY g.game_id' +
			' ORDER BY g.game_rank'
		)
		var ratingIndex = Util.keyed_array(ratingRows, 'g')

		if (!ratingRows.length) {
			return {
				rankings: {
					own: own,
					stats: stats,
					bands: bands,
					average: average,
					ratings: ratings,
					ratingBands: ratingBands
				}
			}
		}

		var streakCount = 0
		var streakLast = null
		var streakStart = 0
		var streakEnd = 0
		var streakLongest = 0
		var rankedTotal = 0
		var maxRank = null
		var minRank = null

		for (var i = 0; i < ratingRows.length; i++) {
			var item = ratingRows[i]
			var rank = parseInt(item.r, 10)

			if (rank > 0) {
				ratings[item.g] = parseFloat(item.v)
				counts[item.g] = parseInt(item.c, 10)
				rankedTotal++

				if (streakLast === null || rank - streakLast === 1) {
					streakLast = rank
					streakCount++
				} else {
					if (streakCount > streakLongest) {
						streakLongest = streakCount
						streakStart = streakLast - (streakCount - 1)
						streakEnd = streakLast
					}

					streakCount = 1
					streakLast = rank
				}

				if (!minRank) minRank = item
				if (!maxRank || rank > parseInt(maxRank.r, 10)) maxRank = item
			}
		}

		if (streakCount > streakLongest) {
			streakLongest = streakCount
			streakStart = streakLast - (streakCount - 1)
			streakEnd = streakLast
		}

		if (maxRank) {
			var minBandRank = (currentBand * 100) + 1
			var maxBandRank = (currentBand + 1) * 100

			for (var bi = 0; bi < Math.ceil(parseInt(maxRank.r, 10) / 100); bi++) {
				bands.push(0)
				average.push(0)
				ratingBands.push([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
			}

			for (var j = 0; j < ratingRows.length; j++) {
				var bandItem = ratingRows[j]
				var bandRank = parseInt(bandItem.r, 10)
				if (bandRank > 0) {
					var bandIndex = Math.floor((bandRank - 1) / 100)
					var count = parseInt(bandItem.c, 10)
					var value = parseFloat(bandItem.v)
					var avgBandRating = count ? Math.floor(value / count) : 0

					bands[bandIndex] += count
					average[bandIndex] += value
					if (avgBandRating >= 0 && avgBandRating < ratingBands[bandIndex].length) {
						ratingBands[bandIndex][avgBandRating] += count
					}
				}
			}

			var gameIndex = Util.query(
				'SELECT g.game_id AS g, g.game_rank AS r' +
				' FROM game g' +
				' WHERE g.game_rank >= ' + minBandRank +
				' AND g.game_rank <= ' + maxBandRank +
				' ORDER BY g.game_rank' +
				' LIMIT 0, 100',
				null,
				'r'
			)

			for (var rankValue = minBandRank; rankValue <= maxBandRank; rankValue++) {
				if (gameIndex[rankValue]) {
					var gameId = parseInt(gameIndex[rankValue].g, 10)
					this._references.games.push(gameId)
					own.push({
						id: gameId,
						rank: rankValue,
						own: !!ratingIndex[gameId],
						rating: ratings[gameId] !== undefined ? (ratings[gameId] / counts[gameId]) : '-',
						count: counts[gameId] !== undefined ? counts[gameId] : '-'
					})
				} else {
					own.push({
						id: 0,
						rank: rankValue,
						own: false,
						rating: '-',
						count: 0
					})
				}
			}

			var bandMostCount = 0
			var bandMostLevel = 0
			var bandNoneLevel = null

			for (var k = 0; k < bands.length; k++) {
				if (bands[k]) stats.levels++
				if (bandMostCount < bands[k]) {
					bandMostLevel = k
					bandMostCount = bands[k]
				}
				if (!bands[k] && bandNoneLevel === null) bandNoneLevel = k
			}

			stats.longest[0] = streakStart
			stats.longest[1] = streakEnd
			stats.levelmost[0] = (bandMostLevel * 100) + 1
			stats.levelmost[1] = (bandMostLevel + 1) * 100

			if (bandNoneLevel !== null) {
				stats.levelnone[0] = (bandNoneLevel * 100) + 1
				stats.levelnone[1] = (bandNoneLevel + 1) * 100
			}

			stats.highest = parseInt(minRank.r, 10)
			stats.lowest = parseInt(maxRank.r, 10)
			stats.top100 = (100 / owner.get_count_ratings()) * (bands[0] || 0)
			stats.top1000 = (100 / owner.get_count_ratings()) * bands.slice(0, 10).reduce(function(sum, value) {
				return sum + value
			}, 0)
			stats.ranked = (100 / owner.get_count_ratings()) * rankedTotal
		}

		return {
			rankings: {
				own: own,
				stats: stats,
				bands: bands,
				average: average,
				ratings: ratings,
				ratingBands: ratingBands
			}
		}

	}
})
